import { useState } from 'react';
import { useLocation } from 'react-router';
import { useSession } from '../lib/SignaSessionContext';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { APP_VERSION } from '../version';

// Ingreso. **Sólo redirección al SSO de Signa** (policies/ux-ui-design.md §5): no hay formulario
// de login local, no hay cuentas propias, no hay contraseñas. Nexa no las tiene ni las va a tener
// (Regla de Oro 3) — y una pantalla que pida usuario y contraseña acá sería, además de una
// violación de arquitectura, un imán de phishing.

export function LoginPage() {
  const { login, configError } = useSession();
  const location = useLocation();
  const [busy, setBusy] = useState(false);

  const returnTo = (location.state as { from?: string } | null)?.from ?? '/inbox';

  return (
    <div className="flex min-h-full items-center justify-center px-4 py-10">
      <Card padding="lg" className="w-full max-w-md animate-in fade-in slide-in-from-bottom-4 duration-500">
        <div className="text-center">
          <h1 className="text-2xl font-semibold tracking-tight text-zinc-900 dark:text-zinc-50">Nexa</h1>
          <p className="mt-2 text-sm leading-relaxed text-zinc-600 dark:text-zinc-400">
            Tus tareas, tus formularios y tus aprobaciones. Entrá con tu cuenta de la organización.
          </p>
        </div>

        {configError ? (
          // Honestidad de configuración, con el nombre exacto de lo que falta: es la lección
          // `EMAIL_PROVIDER = "console"` del ecosistema (policies/deployment.md §0).
          <div
            role="alert"
            className="mt-8 rounded-2xl border border-amber-300/70 bg-amber-50/70 p-6 text-sm text-amber-900
                       dark:border-amber-800/50 dark:bg-amber-950/30 dark:text-amber-100"
          >
            <p className="font-semibold">Este ambiente no tiene configurada la identidad.</p>
            <p className="mt-2 font-mono text-xs">{configError}</p>
            <p className="mt-2">Avisale a quien administra el despliegue: sin eso, nadie puede entrar.</p>
          </div>
        ) : (
          <div className="mt-8">
            <Button
              variant="primary"
              size="lg"
              fullWidth
              loading={busy}
              onClick={() => {
                setBusy(true);
                void login(returnTo).catch(() => setBusy(false));
              }}
            >
              Entrar con Signa
            </Button>
          </div>
        )}

        <p className="mt-8 text-center text-xs text-zinc-500 dark:text-zinc-500">Nexa {APP_VERSION}</p>
      </Card>
    </div>
  );
}

export default LoginPage;
